import { render, staticRenderFns } from "./StudentAllowance.vue?vue&type=template&id=43bd4d66&"
import script from "./StudentAllowance.vue?vue&type=script&lang=js&"
export * from "./StudentAllowance.vue?vue&type=script&lang=js&"
import style0 from "./StudentAllowance.vue?vue&type=style&index=0&id=43bd4d66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports